import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

class Copyright extends React.Component {
  render() {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...this.props}>
        {'Copyright © '}
        <Link color="inherit" href="https://mui.com/">
          Your Website
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
}

export default Copyright;
